<script setup lang="ts">
defineProps<{
  emails: string[]
  downloadLink: string | null
}>()

const emit = defineEmits<{
  download: []
}>()

const { t } = useI18n()
</script>

<template>
  <div class="billing-letter-summary" data-testid="billing-letter-summary">
    <div class="billing-letter-summary__recipients">
      <span class="billing-letter-summary__recipients-label">
        {{ t('receipt-model.billing_letter.recipients') }}
      </span>
      <ul
        v-if="emails.length"
        role="list"
        class="billing-letter-summary__chips"
      >
        <li
          v-for="(email, index) in emails"
          :key="`${index}-${email}`"
          class="billing-letter-summary__chip"
          :data-testid="`billing-letter-recipient-${index}`"
        >
          {{ email }}
        </li>
      </ul>
      <span v-else class="billing-letter-summary__chip-empty">
        -
      </span>
    </div>

    <SolButton
      id="download-billing-letter"
      class="billing-letter-summary__download"
      size="medium"
      variant="secondary"
      :disabled="!downloadLink"
      @click="emit('download')"
    >
      {{ t('receipt-model.billing_letter.download') }}
    </SolButton>
  </div>
</template>

<style lang="scss" scoped>
.billing-letter-summary {
  @apply flex flex-col gap-4xs p-4xs;
  @apply rounded-md border-a-xs border-neutral-high-dark bg-neutral-high-pure;

  @screen sm:system {
    @apply flex-row items-center justify-between gap-2xs;
  }

  &__download {
    @apply flex-shrink-0 self-start whitespace-nowrap;

    @screen sm:system {
      @apply self-center;
    }
  }

  &__recipients {
    @apply flex flex-col gap-quark min-w-0;
  }

  &__recipients-label {
    @apply m-0 fonts-body-medium-bold text-neutral-low-dark;
  }

  &__chips {
    @apply flex flex-wrap gap-nano m-0 p-0 list-none;
  }

  &__chip {
    @apply max-w-full px-micro py-[6px] rounded-sm bg-neutral-high-light;
    @apply fonts-body-large-regular text-neutral-low-medium break-all;
  }

  &__chip-empty {
    @apply m-0 fonts-body-large-regular text-neutral-low-light;
  }
}
</style>
